import { useState } from "react";

export default function PasswordField({ id, label, value, onChange, autoComplete, hint }: {
  id: string; label: string; value: string; onChange: (value: string) => void;
  autoComplete: string; hint?: string;
}) {
  const [visible, setVisible] = useState(false);
  return <div className="auth-field">
    <label htmlFor={id}>{label} <span className="auth-required">*</span></label>
    <div className="auth-password">
      <input id={id} type={visible ? "text" : "password"} value={value} onChange={e => onChange(e.target.value)}
        required maxLength={64} autoComplete={autoComplete} aria-describedby={hint ? `${id}-hint` : undefined} />
      <button type="button" onClick={() => setVisible(!visible)} aria-label={`${label} ${visible ? "숨기기" : "표시"}`} aria-pressed={visible}>{visible ? "숨김" : "표시"}</button>
    </div>
    {hint && <small id={`${id}-hint`}>{hint}</small>}
  </div>;
}
